export const isEmpty = v => v === null || v === undefined || v === ''
export const isNonEmpty = v => !isEmpty(v)
export const orNull = (v, format = x => x) => isEmpty(v) ? null : format(v)
export const orDash = (v, format = x => x) => isEmpty(v) ? '--' : format(v)
